import Link from 'next/link';
import React from 'react';
import { BecomeAmbassadorProps } from './become-ambassador.props';

export const BecomeAmbassadorMolecule = (props: BecomeAmbassadorProps) => {
  return (
    <Link href={props.href}>
      <a
        className="button btn-cta block w-full  mx-auto font-waldo-header font-light"
        aria-label="BECOME AN AMBASSADOR"
      >
        {props.label}
      </a>
    </Link>
  );
};
